<template>
  <div v-if="item">

    <h5>Внимание! Если вы сохраните пароль, пользователь получит пригласительное смс с паролем</h5>
    <br/>
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "business/customers",
    cardSetLink: "business/customers",
    item: null,
    fields: [
             {
                    col:'col-12 col-md-6',
                    key: "password",
                    label: "Новый пароль (минимум 5 символов)",
                    type: "field",
                    textType: "text",
              },
      ],
  }),
  props: ["id"],
  async created() {
    if (this.id) {
        this.item = {
          id: this.id,
          password: ''
        };
    }
  },
  methods: {
    cardUpdate: cardUpdate,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
